import { useState, type ReactNode } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'

// A real confirmation step for destructive actions.
//
// cancel.php announced "HUOM! Varmistuksia ei kysellä" -- no confirmations
// asked -- and deleted whatever was ticked. Cancelling a flight someone
// planned their weekend around deserves one dialog.
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  destructive = true,
  reasonLabel,
  reasonRequired = false,
  onConfirm,
  onClose,
}: {
  open: boolean
  title: string
  message: ReactNode
  confirmLabel: string
  cancelLabel: string
  destructive?: boolean
  reasonLabel?: string
  reasonRequired?: boolean
  onConfirm: (reason?: string) => void
  onClose: () => void
}) {
  const [reason, setReason] = useState('')
  const blocked = reasonRequired && reason.trim().length === 0

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">{message}</DialogContentText>
        {reasonLabel ? (
          <TextField
            autoFocus
            fullWidth
            multiline
            minRows={2}
            margin="dense"
            label={reasonLabel}
            required={reasonRequired}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{cancelLabel}</Button>
        <Button
          variant="contained"
          color={destructive ? 'error' : 'primary'}
          disabled={blocked}
          onClick={() => {
            onConfirm(reasonLabel ? reason.trim() : undefined)
            setReason('')
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
